import { render, staticRenderFns } from "./VuesticFileUploadGalleryItem.vue?vue&type=template&id=9485e1b4"
import script from "./VuesticFileUploadGalleryItem.vue?vue&type=script&lang=js"
export * from "./VuesticFileUploadGalleryItem.vue?vue&type=script&lang=js"
import style0 from "./VuesticFileUploadGalleryItem.vue?vue&type=style&index=0&id=9485e1b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports